"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _fingerprintjs = _interopRequireDefault(require("fingerprintjs2"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var FingerprintProvider = function FingerprintProvider(_a) {
  var settings = _a.settings,
      children = _a.children;
  (0, _react.useEffect)(function () {
    if (settings.FEATURE.FINGERPRINT && !window.localStorage['@lce/local/uuid']) {
      _fingerprintjs["default"].get(function (components) {
        var values = components.map(function (component) {
          return component.value;
        });

        var hash = _fingerprintjs["default"].x64hash128(values.join(''), 31); // tslint:disable-next-line: strict-type-predicates


        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem('@lce/local/uuid', hash);
        }
      });
    }
  }, [settings.FEATURE.FINGERPRINT]);
  return _react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = FingerprintProvider;
exports["default"] = _default;